import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Dialog, IconButton} from 'material-ui';
import UserForm from '../../form/UserForm';
import * as userActions from '../../actions/userAction';
import {cyan400, white} from 'material-ui/styles/colors';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import {Link} from 'react-router';
import toastr from 'toastr';

class UserPopinContainer extends React.Component {

    storeUser(data) {
        if (data.id) {
            this.props.userActions.update(data).then(() => {
                this.context.router.goBack();
                toastr.success('Utilisateur modifié avec succès','Modification d\'un utilisateur');
            });
        } else {
            this.props.userActions.store(data).then(() => {
                this.context.router.goBack();
                toastr.success('Utilisateur ajouté avec succès','Création d\'un utilisateur');
            });
        }
    }

    validate(data) {
        return {};
    }


    render() {
        const titleStyle = {
            padding: 10,
            margin: 0,
            backgroundColor: cyan400,
            color: white
        };
        const validate = this.validate.bind(this);
        const storeUser = this.storeUser.bind(this);
        const user = (this.props.user.length == 1) ? this.props.user[0] : null;
        const popinTitle = (user) ? "Modifier un utilisateur" : "Ajouter un utilisateur";
        const popinHeader = (
            <div>
                {popinTitle}
                <Link to={'/user'}>
                    <IconButton style={{position: 'absolute', top: 0, right: 0}}>
                        <CloseIcon color={white}/>
                    </IconButton>
                </Link>
            </div>);
        return (
            <Dialog titleStyle={titleStyle} contentStyle={{maxWidth: 500}} open title={popinHeader}>
                <UserForm {...this.props} onSubmit={storeUser} validate={validate}/>
            </Dialog>
        );
    }
}

UserPopinContainer.propTypes = {
    userActions: PropTypes.object,
    user: PropTypes.array
};

UserPopinContainer.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        user: state.users.filter((user) => user.id == ownProps.routeParams.user)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPopinContainer);


/** WEBPACK FOOTER **
 ** ./src/container/UserPopinContainer/index.js
 **/